import { CardButton, SlideAction, useSlideLayout } from '@gripp/shared-ui';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';
import { IAccountSettings } from '../interfaces';
import { SETTINGS_ACCOUNT_SETTINGS_PAGES } from '../settingColumns';

export const AccountSettingsMenu = () => {
  const { t } = useTranslation();
  const { columnData, currentColumnId, onSlideColumnChange, switchViewMode} = useSlideLayout();
  const [ currentSettingPage, setCurrentSettingPage ] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (columnData && columnData['settings']) {
      const accountSettingsProps = columnData['settings'] as IAccountSettings;
      setCurrentSettingPage(accountSettingsProps.page || undefined);
    }
  }, [columnData]);

  return (
    <View style={styles.container}>
      <Text variant='bodyLarge'>{t('preferences.menu.title')}</Text>
      <CardButton 
        showAvatars={false}
        leftIcon={'Profile'}
        text={t('preferences.settings.profile')}
        onPress={() => onSlideColumnChange(SlideAction.PREV, '', {page: SETTINGS_ACCOUNT_SETTINGS_PAGES.PROFILE})}
        active={currentSettingPage === SETTINGS_ACCOUNT_SETTINGS_PAGES.PROFILE}
      />
      <CardButton 
        showAvatars={false}
        leftIcon={'Settings'}
        text={t('preferences.settings.notifications')}
        onPress={() => onSlideColumnChange(SlideAction.PREV, '', {page: SETTINGS_ACCOUNT_SETTINGS_PAGES.PREFERENCES})}
        active={currentSettingPage === SETTINGS_ACCOUNT_SETTINGS_PAGES.PREFERENCES}
      />

      { /* TODO: Crop Circle Redesign | Remove this column when the redesign is done  */ }
      <View style={{ marginTop: 32 }}>
        <CardButton
          showAvatars={false}
          color='orange'
          leftIcon={'Profile'}
          text={'This is just a test to navigate the column, now the next column will always be preferences'}
          onPress={() => onSlideColumnChange(SlideAction.NEXT, currentColumnId)}
        />
      </View>

      <CardButton
        showAvatars={false}
        color='orange'
        leftIcon={'Profile'}
        text={'This is just a test to Toggle View Mode'}
        onPress={() => switchViewMode()}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    gap: 12,
    marginTop: 16,
  },
});
